// extracted by mini-css-extract-plugin
export default {"switch":"ToogleSwitch_switch__GaUVi","slider":"ToogleSwitch_slider__47bB+","round":"ToogleSwitch_round__+39d6"};